import { render, staticRenderFns } from "./BaseScreeningPage.vue?vue&type=template&id=f889b57e&scoped=true&"
import script from "./BaseScreeningPage.vue?vue&type=script&lang=js&"
export * from "./BaseScreeningPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseScreeningPage.vue?vue&type=style&index=0&id=f889b57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f889b57e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VDivider,VIcon,VRow})
